module.exports = __webpack_public_path__ + "static/media/location-maps-letter-f-arrow.f0dd9609.png";